// extracted by mini-css-extract-plugin
export default {"selfAssessment":"SelfAssessment_selfAssessment__G7l6O"};